import {
  SEARCH_PARAM_ORG_ID,
  SEARCH_PARAM_SITE_ID,
} from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

export const SEARCH_PARAM_POINT_CLOUD_OR_SCENE_ID = 'pointCloudOrSceneId'
export const SEARCH_PARAM_CAMERA_POS = 'cameraPos'
export const SEARCH_PARAM_CAMERA_TARGET = 'cameraTarget'

export const pointCloudIndexSearchParams = z.object({
  [SEARCH_PARAM_SITE_ID]: z.string(),
})

export const pointCloudViewSearchParams = z.object({
  ...pointCloudIndexSearchParams.shape,
  [SEARCH_PARAM_POINT_CLOUD_OR_SCENE_ID]: z.string(),
  [SEARCH_PARAM_CAMERA_POS]: z.string().optional(), // Expecting "x,y,z"
  [SEARCH_PARAM_CAMERA_TARGET]: z.string().optional(), // Expecting "x,y,z"
})

type PointCloudIndexSearchInput = {
  orgId: string | undefined
  siteId: string
}

type PointCloudViewSearchInput = PointCloudIndexSearchInput & {
  pointCloudOrSceneId: string
  cameraPos: string | undefined
  cameraTarget: string | undefined
}

export const createPointCloudIndexSearch = ({
  orgId,
  siteId,
}: PointCloudIndexSearchInput) => ({
  [SEARCH_PARAM_ORG_ID]: orgId,
  [SEARCH_PARAM_SITE_ID]: siteId,
})

export const createPointCloudViewSearch = ({
  orgId,
  siteId,
  pointCloudOrSceneId,
  cameraPos,
  cameraTarget,
}: PointCloudViewSearchInput) => ({
  ...createPointCloudIndexSearch({ orgId, siteId }),
  [SEARCH_PARAM_POINT_CLOUD_OR_SCENE_ID]: pointCloudOrSceneId,
  [SEARCH_PARAM_CAMERA_POS]: cameraPos,
  [SEARCH_PARAM_CAMERA_TARGET]: cameraTarget,
})
